import { Link } from "react-router-dom";
import PageShell from "../components/PageShell";

const serviceCards = [
  {
    title: (
      <>
        <span className="b-style">B</span>randing
        <br />& Logo
        <br />
        Design
      </>
    ),
    type: "text",
    arrow: "up"
  },
  {
    type: "image",
    src: "/assets/image/services/phone.jpg",
    alt: "Graphic design service"
  },
  {
    type: "image",
    src: "/assets/image/services/studio.jpg",
    alt: "Studio service"
  },
  {
    title: (
      <>
        Thumbnail
        <br />
        <span className="d-style">D</span>esign
      </>
    ),
    type: "text",
    arrow: "right"
  },
  {
    title: (
      <>
        Soci<span className="a-style">a</span>l
        <br />
        <span className="m-style">M</span>edia
        <br />
        Post
      </>
    ),
    type: "text",
    arrow: "up"
  },
  {
    type: "image",
    src: "/assets/image/services/baby.jpg",
    alt: "Memory portrait"
  },
  {
    type: "image",
    src: "/assets/image/services/camera.jpg",
    alt: "Photography service"
  },
  {
    title: (
      <>
        <span className="d-style">C</span>oming
        <br />
        Soon
      </>
    ),
    type: "text",
    arrow: "right"
  }
];

export default function ServicesPage() {
  return (
    <PageShell pageClass="page-services">
      <section className="container">
        <h1 className="page-title text-center">Services</h1>
        <div className="service-grid">
          {serviceCards.map((card, index) =>
            card.type === "image" ? (
              <div className="service-card image-card" key={card.src}>
                <img src={card.src} alt={card.alt} />
              </div>
            ) : (
              <div className="service-card text-card" key={`text-${index}`}>
                <div className="service-card-text">
                  <h3>{card.title}</h3>
                  <span className="service-arrow">
                    {card.arrow === "up" ? "\u2191" : "\u2192"}
                  </span>
                </div>
              </div>
            )
          )}
        </div>

        <section className="popular-services spacing-top">
          <h2>Popular Services</h2>
          <div className="popular-grid">
            <div className="relative overflow-hidden">
              <img
                src="/assets/image/complete bundle start.jpg"
                alt="Popular service 1"
              />
              <Link
                to="/services"
                className="absolute bottom-8 left-5 inline-flex items-center justify-center rounded-none bg-[#d7ff1f] px-5 py-3 font-display text-lg font-medium text-accent shadow-[0_10px_18px_rgba(0,0,0,0.22)] transition duration-300 hover:-translate-y-0.5 hover:brightness-105 md:bottom-10 md:left-7 md:min-w-[140px] md:text-[1.55rem]"
              >
                Know More
              </Link>
            </div>
            <div className="relative overflow-hidden">
              <img
                src="/assets/image/complete bundle.jpg"
                alt="Popular service 2"
              />
              <Link
                to="/services"
                className="absolute bottom-8 left-5 inline-flex items-center justify-center rounded-none bg-[#d7ff1f] px-5 py-3 font-display text-lg font-medium text-accent shadow-[0_10px_18px_rgba(0,0,0,0.22)] transition duration-300 hover:-translate-y-0.5 hover:brightness-105 md:bottom-10 md:left-7 md:min-w-[140px] md:text-[1.55rem]"
              >
                Know More
              </Link>
            </div>
          </div>
        </section>
      </section>
    </PageShell>
  );
}
